import React, { useState } from "react";
import classes from "../style/Style.module.css";
import "../style/LoginScreen.scss";
import {
  Dexter_Splash4,
  ROUTE_PORT_FOLIO,
  ROUTE_HOLD_INVESTMENT,
  ROUTE_INVESTMENT_PROFILE,
  ROUTE_RESIDENTIAL_STATUS,
  ROUTE_DEPENDED_PEOPLE,
  ROUTE_DXTER_SCANNING,
} from "../Routes";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../libs/axiosConfig";
import { ToastContainer } from "react-toastify";
import Toast from "../Components/ToastMsg/Toast";
import { useDispatch } from "react-redux";
import { setAccessToken } from "../Store/Token/AuthTokenSlice";
import { setRefreshToken } from "../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../Images/NewDexterLogo.svg";

import { setUpdatedPortfolioData } from "../Store/UpdatedPortfolioData/updatedPortfolioActions";
import { setPanNumber } from "../Store/panNumberSlice";
import { setSelectedPortfolioType } from "../Store/UpdatedPortfolioData/userPortfolioSlice";

const VerifyOtp = () => {
  const [userOtp, setUserOtp] = useState("");
  const [seconds, setSeconds] = useState("");
  const [timerId, setTimerId] = useState(null);
  const [verificationError, setVerificationError] = useState(false);
  const Navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId || "";
  const ResponseFristApi = location.state?.ResponseFristApi || "";
  const SecondApiRes = location.state?.SecondApiRes || "";
  const phoneNumber = location.state?.phoneNumber || "";
  console.log(phoneNumber)

  const [verifyButtonClicked, setVerifyButtonClicked] = useState(false);
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");

    setUserOtp(input);
  };

  // //console.log(mobileOTP,"passed")
  const handleClearButtonClick = () => {
    setUserOtp("");
  };

  const handleResendButtonClick = async () => {
    setSeconds(59);
    if (timerId) {
      clearInterval(timerId);
    }
    const id = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          clearInterval(id);
          return "";
        }
        return prevSeconds - 1;
      });
    }, 1000);
    setTimerId(id);

    const apiUrl =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

      const requestBody = {
        loginUserInfo: {
          countryCode: "+91",
          mobileNumber: phoneNumber,
          job: "sendOtp"
          }
      };
      axios
        .post(apiUrl, requestBody)
        .then((response) => {
          if (response.status === 200) {


            const accessToken = response.data.data.accessToken;
            dispatch(setAccessToken(response.data.data.accessToken));
            dispatch(setRefreshToken(response.data.data.refreshToken));

            // Call the Dexterr Question API
            callDexterrQuestionApi(accessToken);
            
            
          } else if (
            response.status === 400 &&
            response.data.message === "Invalid otp"
          ) {
            setVerificationError(true);
           
            return;
          } else {
            setVerificationError(true);
            //console.error("Unexpected response from the first API:", response);
            Toast.error(
              response.data.message + " " + response.data.errorMessage
            );
            return;
          }
        })
        .catch((error) => {
          setVerificationError(true);
          //console.error("First API call failed:", error);
          Toast.error("Error During OTP Verification");
          return;
        });
        


    // Call the appropriate API based on which API was called previously
    // if (ResponseFristApi) {
    //   const apiUrl =
    //     "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

    //   if (!phoneNumber) {
    //     Toast.error("please enter valid phone number");
    //     // //console.error("Mobile number is required.");
    //     return;
    //   }
    //   const countryCode = "+91";
    //   const requestBody = {
    //     loginUserInfo: {
    //       countryCode: "+91",
    //       mobileNumber: phoneNumber,
    //       job: "verifyOtp",
    //       otp: userOtp
    //     }
    //   };

    //   try {
    //     const response = await axios.post(apiUrl, requestBody, {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     });

    //     if (response.status === 200) {
    //       callDexterrQuestionApi()
    //     } else {

    //       Toast.error(response.data.message + " " + response.data.errorMessage);
    //     }
    //   } catch (error) {

    //     Toast.error("An error occurred during resend OTP");
    //   }
    // } else if (SecondApiRes) {
    //   // Call the second API for resending OTP
    //   const resendApiUrl =
    //     "https://partnerapp.ambrela.money/api/DexterrCustomerSendOtp";
    //   const resendApiRequestBody = {
    //     countryCode: "+91",
    //     phoneNumber,
    //     userId: "",
    //     otp_for: "login",
    //   };

    //   try {
    //     const resendApiResponse = await axios.post(
    //       resendApiUrl,
    //       resendApiRequestBody,
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     );

    //     if (resendApiResponse.status === 200) {
    //       // Toast.success(resendApiResponse.data.message);
    //       setSeconds(59);
    //     } else {
    //       //console.error(
    //       //   "Resend OTP API request failed:",
    //       //   resendApiResponse.statusText
    //       // );
    //       Toast.error(
    //         resendApiResponse.data.message +
    //         " " +
    //         resendApiResponse.data.errorMessage
    //       );
    //     }
    //   } catch (error) {
    //     //console.error("An error occurred during resend OTP:", error);
    //     Toast.error("An error occurred during resend OTP");
    //   }
    // }
  };

  const handleVerifyOtp = () => {
    setVerifyButtonClicked(true);

    // First condition: Check if userOtp has 6 digits
    if (userOtp.length !== 6) {
      setVerificationError(true);
      Toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    // Second condition: Check if both APIs have been successfully called (status 200)
    // if (ResponseFristApi) {
      const apiUrl =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

      const requestBody = {
        loginUserInfo: {
          countryCode: "+91",
          mobileNumber: phoneNumber,
          job: "verifyOtp",
          otp: userOtp
        }
      };
      axios
        .post(apiUrl, requestBody)
        .then((response) => {
          if (response.status === 200) {


            const accessToken = response.data.data.accessToken;
            dispatch(setAccessToken(response.data.data.accessToken));
            dispatch(setRefreshToken(response.data.data.refreshToken));

            // Call the Dexterr Question API
            callDexterrQuestionApi(accessToken);
            console.log("calling dexterr api")
            // Navigate(Dexter_Splash4);
            // console.log("navigating")
          } else if (
            response.status === 400 &&
            response.data.message === "Invalid otp"
          ) {
            setVerificationError(true);
            //console.error("Invalid OTP for the first API");
            Toast.error(
              response.data.message + " " + response.data.errorMessage
            );
            return;
          } else {
            setVerificationError(true);
            //console.error("Unexpected response from the first API:", response);
            Toast.error(
              response.data.message + " " + response.data.errorMessage
            );
            return;
          }
        })
        .catch((error) => {
          setVerificationError(true);
          //console.error("First API call failed:", error);
          Toast.error("Error During OTP Verification");
          return;
        });
    // }

    // Call the second API only if SecondApiRes is truthy
    // if (SecondApiRes) {
    //   const secondApiUrl =
    //     "https://partnerapp.ambrela.money/api/DexterrCustomerLogin";
    //   const secondApiRequestBody = {
    //     countryCode: "+91",
    //     phoneNumber: phoneNumber,
    //     otp: userOtp,
    //   };

    //   axios
    //     .post(secondApiUrl, secondApiRequestBody)
    //     .then((secondApiResponse) => {
    //       if (
    //         secondApiResponse.status === 200 &&
    //         secondApiResponse.data &&
    //         secondApiResponse.data.data
    //       ) {
    //         // Second API call was successful
    //         const accessToken = secondApiResponse.data.data.accessToken;
    //         dispatch(setAccessToken(accessToken));
    //         dispatch(setRefreshToken(secondApiResponse.data.data.refreshToken));

    //         // Toast.success(secondApiResponse.data.message)
    //         // Call the Dexterr Question API
    //         callDexterrQuestionApi(accessToken);
    //       } else {
    //         //console.error("Second API failed:", secondApiResponse.statusText);
    //         Toast.error(
    //           secondApiResponse.data.message +
    //           " " +
    //           secondApiResponse.data.errorMessage
    //         );

    //         // Toast.error(secondApiResponse.data.message + " " +secondApiResponse.data.errorMessage );
    //       }
    //     })
    //     .catch((error) => {
    //       //console.error("Second API call failed:", error);
    //       Toast.error("Invalid Otp");
    //     });
    // }
  };

  const callDexterrQuestionApi = (accessToken) => {
    const apiUrl =
      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
    const requestBody = {
      dexterrCustomerBasicQuestions: {
        mobile_no: phoneNumber,
        request_type: "get",
        country_code: "+91",
      }
    };

    axios
      .post(apiUrl, requestBody, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data && response.data.data) {
          const data = response.data.data;
          //console.log(response.data.data.pan);
          // Toast.success(response.data.message)
          dispatch(setPanNumber(response.data.data.pan_number));
          if (
            data.resident === null ||
            data.investment_years === null ||
            data.investment_profile === null ||
            data.financial_dependant === null ||
            data.temporary_drop_percentage_portfolio === null
          ) {
            if (data.resident === null) {
              Navigate(ROUTE_RESIDENTIAL_STATUS);
            } else if (data.investment_years === null) {
              Navigate(ROUTE_HOLD_INVESTMENT);
            } else if (data.investment_profile === null) {
              Navigate(ROUTE_INVESTMENT_PROFILE);
            } else if (data.financial_dependant === null) {
              Navigate(ROUTE_DEPENDED_PEOPLE);
            } else if (data.temporary_drop_percentage_portfolio === null) {
              Navigate(ROUTE_PORT_FOLIO);
            }
          } else {
            const {
              pan,
              resident,
              investment_years,
              investment_profile,
              temporary_drop_percentage_portfolio,
            } = response.data.data;
            Navigate(ROUTE_DXTER_SCANNING, {
              state: {
                ApiData: {
                  pan,
                  resident,
                  investment_years,
                  investment_profile,
                  temporary_drop_percentage_portfolio,
                },
              },
            });
          }
        } else {
          //console.error(
          //   "Unexpected response from the Dexterr Question API:",
          //   response
          // );
          Toast.error("Error During OTP Verification");
        }
      })
      .catch((error) => {
        //console.error("Dexterr Question API call failed:", error);
        Toast.error("Error During OTP Verification");
      });
  };

  // const handleVerifyOtp = () => {
  //   setVerifyButtonClicked(true);

  //   // First condition: Check if userOtp has 6 digits
  //   if (userOtp.length !== 6) {
  //     setVerificationError(true);
  //     Toast.error("Please enter a valid 6-digit OTP");
  //     return;
  //   }

  //   // Second condition: Check if both APIs have been successfully called (status 200)
  //   if (ResponseFristApi) {
  //     const apiUrl =
  //       "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

  //     const requestBody = {
  //       loginUserInfo: {
  //         countryCode: "+91",
  //         mobileNumber: phoneNumber,
  //         job: "verifyOtp",
  //         otp: userOtp
  //       }
  //     };
  //     axios
  //       .post(apiUrl, requestBody)
  //       .then((response) => {
  //         if (response.status === 200 && response.data && response.data.data) {


  //           const accessToken = response.data.data.accessToken;
  //           dispatch(setAccessToken(response.data.data.accessToken));
  //           dispatch(setRefreshToken(response.data.data.refreshToken));

  //           // Call the Dexterr Question API
  //           callDexterrQuestionApi(accessToken);
  //           Navigate(Dexter_Splash4);
  //         } else if (
  //           response.status === 400 &&
  //           response.data.message === "Invalid otp"
  //         ) {
  //           setVerificationError(true);
  //           //console.error("Invalid OTP for the first API");
  //           Toast.error(
  //             response.data.message + " " + response.data.errorMessage
  //           );
  //           return;
  //         } else {
  //           setVerificationError(true);
  //           //console.error("Unexpected response from the first API:", response);
  //           Toast.error(
  //             response.data.message + " " + response.data.errorMessage
  //           );
  //           return;
  //         }
  //       })
  //       .catch((error) => {
  //         setVerificationError(true);
  //         //console.error("First API call failed:", error);
  //         Toast.error("Error During OTP Verification");
  //         return;
  //       });
  //   }

  //   // Call the second API only if SecondApiRes is truthy
  //   if (SecondApiRes) {
  //     const secondApiUrl =
  //       "https://partnerapp.ambrela.money/api/DexterrCustomerLogin";
  //     const secondApiRequestBody = {
  //       countryCode: "+91",
  //       phoneNumber: phoneNumber,
  //       otp: userOtp,
  //     };

  //     axios
  //       .post(secondApiUrl, secondApiRequestBody)
  //       .then((secondApiResponse) => {
  //         if (
  //           secondApiResponse.status === 200 &&
  //           secondApiResponse.data &&
  //           secondApiResponse.data.data
  //         ) {
  //           // Second API call was successful
  //           const accessToken = secondApiResponse.data.data.accessToken;
  //           dispatch(setAccessToken(accessToken));
  //           dispatch(setRefreshToken(secondApiResponse.data.data.refreshToken));

  //           // Toast.success(secondApiResponse.data.message)
  //           // Call the Dexterr Question API
  //           callDexterrQuestionApi(accessToken);
  //         } else {
  //           //console.error("Second API failed:", secondApiResponse.statusText);
  //           Toast.error(
  //             secondApiResponse.data.message +
  //             " " +
  //             secondApiResponse.data.errorMessage
  //           );

  //           // Toast.error(secondApiResponse.data.message + " " +secondApiResponse.data.errorMessage );
  //         }
  //       })
  //       .catch((error) => {
  //         //console.error("Second API call failed:", error);
  //         Toast.error("Invalid Otp");
  //       });
  //   }
  // };

  return (
    <div className="Login_Mobile_Main_Container">
      <header className="Login_Splash1Header">
        <img alt="" src={NewDexterLogo} className="Login_DexterLogo" />
      </header>
      <div className="Login_Input_Div_Container">
        <p className="Login_Input_Heading_text">Verify with OTP</p>
        <span className="Login_Input_Sub_heading">
          Please enter the 6 digit OTP sent to your mobile number.
        </span>
        <div className="Login_Input_Filed_Box">
          <span className="Login_Enter_mobile_text">Enter OTP</span>
          <div className="Login_Input_Inner_Container">
            <input
              className={classes.Input_Filed}
              value={userOtp}
              onChange={handleInputChange}
              maxLength={6}
            />
            <button
              className="Login_Cross_button"
              onClick={handleClearButtonClick}
            />
          </div>
        </div>
        <div className={classes.Button_Container}>
          <button
            className={`${classes.Resend_Otp_Btn} ${verificationError && verifyButtonClicked
              ? classes.Resend_Error
              : ""
              }`}
            style={{
              background: verifyButtonClicked ? "white" : "white",
            }}
            onClick={handleResendButtonClick}
          >
            Resend
          </button>

          <button className={classes.Verify_Otp_Btn} onClick={handleVerifyOtp}>
            Verify OTP
          </button>
        </div>
        <span className={classes.Waring_text}>
          Haven't received OTP yet? You can request for another OTP by clicking
          on Resend OTP
        </span>
      </div>
      <ToastContainer />
    </div>
  );
};

export default VerifyOtp;
